"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KHInputProviderMouse = exports.KHMouseBindableInput = exports.KHMouseAxis = exports.KHMouseInput = void 0;
const KHInputAxis_1 = require("./Axis/KHInputAxis");
const KHInputKey_1 = require("./Key/KHInputKey");
const KHInputProvider_1 = require("./KHInputProvider");
var KHMouseInput;
(function (KHMouseInput) {
    KHMouseInput[KHMouseInput["Left"] = 0] = "Left";
    KHMouseInput[KHMouseInput["Right"] = 1] = "Right";
})(KHMouseInput = exports.KHMouseInput || (exports.KHMouseInput = {}));
var KHMouseAxis;
(function (KHMouseAxis) {
    KHMouseAxis[KHMouseAxis["X"] = 0] = "X";
    KHMouseAxis[KHMouseAxis["Y"] = 1] = "Y";
    KHMouseAxis[KHMouseAxis["Scroll"] = 2] = "Scroll";
})(KHMouseAxis = exports.KHMouseAxis || (exports.KHMouseAxis = {}));
var KHMouseBindableInput;
(function (KHMouseBindableInput) {
    KHMouseBindableInput[KHMouseBindableInput["LMB"] = 0] = "LMB";
    KHMouseBindableInput[KHMouseBindableInput["LMBTap"] = 1] = "LMBTap";
    KHMouseBindableInput[KHMouseBindableInput["LMBHold"] = 2] = "LMBHold";
    KHMouseBindableInput[KHMouseBindableInput["RMB"] = 3] = "RMB";
    KHMouseBindableInput[KHMouseBindableInput["RMBTap"] = 4] = "RMBTap";
    KHMouseBindableInput[KHMouseBindableInput["RMBHold"] = 5] = "RMBHold";
    KHMouseBindableInput[KHMouseBindableInput["ScrollUp"] = 6] = "ScrollUp";
    KHMouseBindableInput[KHMouseBindableInput["ScrollDown"] = 7] = "ScrollDown";
})(KHMouseBindableInput = exports.KHMouseBindableInput || (exports.KHMouseBindableInput = {}));
class KHInputProviderMouse extends KHInputProvider_1.KHInputProvider {
    constructor(scene) {
        super();
        this.scene = scene;
        this.input = new Map();
        this.input.set(KHMouseInput.Left, new KHInputKey_1.KHInputKey());
        this.input.set(KHMouseInput.Right, new KHInputKey_1.KHInputKey());
        this.axis = new Map();
        this.axis.set(KHMouseAxis.X, new KHInputAxis_1.KHInputAxis());
        this.axis.set(KHMouseAxis.Y, new KHInputAxis_1.KHInputAxis());
        this.axis.set(KHMouseAxis.Scroll, new KHInputAxis_1.KHInputAxis());
        this.scene.input.on('wheel', (pointer, currentlyOver, dx, dy, dz, event) => {
            this.wheelCallbackState = pointer.deltaY;
        });
    }
    update(now, delta) {
        const pointer = this.scene.input.activePointer;
        this._updateInput(KHMouseInput.Left, pointer.leftButtonDown());
        this._updateInput(KHMouseInput.Right, pointer.rightButtonDown());
        this._updateAxis(KHMouseAxis.X, pointer.x);
        this._updateAxis(KHMouseAxis.Y, pointer.y);
        // Ostensibly we could set scrollwheel from pointer.deltaY here, but
        // that has a strange habit of not getting cleared across frames. By
        // using the callback value and clearing it after reading it, we
        // can ensure it is cleared ourselves.
        this._updateAxis(KHMouseAxis.Scroll, this.wheelCallbackState);
        this.wheelCallbackState = 0;
    }
    _updateInput(input, value) {
        this.input.get(input).update(value);
        if (value) {
            KHInputProvider_1.KHInputProvider.lastInputSource = this;
        }
    }
    _updateAxis(axis, value) {
        if (this.axis.get(axis).update(value)) {
            KHInputProvider_1.KHInputProvider.lastInputSource = this;
        }
    }
    getInput(input) {
        return this.input.get(input);
    }
    getAxis(axis) {
        return this.axis.get(axis);
    }
    type() {
        return KHInputProviderMouse.INPUT_TYPE;
    }
    getId() {
        return "Mouse";
    }
}
exports.KHInputProviderMouse = KHInputProviderMouse;
KHInputProviderMouse.INPUT_TYPE = "mouse";
